/**
 * prefers-reduced-motion query — single source of truth.
 *
 * Returns true if the user has explicitly requested reduced motion.
 * Reactive: rerun on change events if you want to respond live.
 */
const mql =
  typeof window !== "undefined" ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;

export function useReducedMotion(): boolean {
  return mql?.matches ?? false;
}

export function onReducedMotionChange(cb: (reduced: boolean) => void): () => void {
  if (!mql) return () => {};
  const handler = (e: MediaQueryListEvent) => cb(e.matches);
  mql.addEventListener("change", handler);
  return () => mql.removeEventListener("change", handler);
}
